module.exports = __webpack_public_path__ + "static/media/Sports.b694bfe2.svg";